// Maps Arabic-Indic (٠-٩) and Persian (۰-۹) digits to Western digits so numeric inputs accept them.
export const toEnglishDigits = (value) =>
  String(value ?? "")
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0));

// Western digits -> Arabic-Indic, for display only (the stored value stays a plain number).
export const toArabicDigits = (value) =>
  String(value ?? "").replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);

// antd InputNumber `formatter` factory: show Arabic-Indic digits in Arabic mode.
export const digitsFormatter = (isArabic) => (value) =>
  isArabic ? toArabicDigits(value) : String(value ?? "");

// antd InputNumber `parser`: normalise digits and drop everything that isn't a digit.
export const digitsParser = (value) => toEnglishDigits(value).replace(/\D/g, "");
